import api from './axiosConfig';

// ─── AUTH ─────────────────────────────────────────────────────
export const authApi = {
  login: (credentials) => api.post('/auth/login', credentials),
  logout: () => api.post('/auth/logout'),
  refresh: (refreshToken) => api.post('/auth/refresh', { refreshToken }),
  me: () => api.get('/auth/me'),
  changePassword: (data) => api.put('/auth/change-password', data),
};

// ─── USERS ────────────────────────────────────────────────────
export const usersApi = {
  getAll: (params) => api.get('/users', { params }),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
};

// ─── INVENTORY ───────────────────────────────────────────────
export const inventoryApi = {
  getLots: (params) => api.get('/inventory/lots', { params }),
  createLot: (data) => api.post('/inventory/lots', data),
  updateLot: (id, data) => api.put(`/inventory/lots/${id}`, data),
  getLotById: (id) => api.get(`/inventory/lots/${id}`),
  getInventory: (params) => api.get('/inventory', { params }),
  getById: (id) => api.get(`/inventory/${id}`),
  getLowStock: () => api.get('/inventory/low-stock'),
  adjustStock: (id, data) => api.post(`/inventory/${id}/adjust`, data),
  getHistory: (id, params) => api.get(`/inventory/${id}/history`, { params }),
};

// ─── ACCESSORIES ─────────────────────────────────────────────
export const accessoriesApi = {
  getAll: (params) => api.get('/accessories', { params }),
  getById: (id) => api.get(`/accessories/${id}`),
  create: (data) => api.post('/accessories', data),
  update: (id, data) => api.put(`/accessories/${id}`, data),
  restock: (id, quantity) => api.post(`/accessories/${id}/restock`, { quantity }),
  getTemplates: () => api.get('/accessories/templates'),
  createTemplate: (data) => api.post('/accessories/templates', data),
  updateTemplate: (id, data) => api.put(`/accessories/templates/${id}`, data),
};

// ─── CUSTOMERS ───────────────────────────────────────────────
export const customersApi = {
  getAll: (params) => api.get('/customers', { params }),
  getById: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
};

// ─── SUPPLIERS ───────────────────────────────────────────────
// export const suppliersApi = {
//   getAll: (params) => api.get('/suppliers', { params }),
//   create: (data) => api.post('/suppliers', data),
//   update: (id, data) => api.put(`/suppliers/${id}`, data),
//   delete: (id) => api.delete(`/suppliers/${id}`),
// };

// ─── ORDERS ──────────────────────────────────────────────────
export const ordersApi = {
  getAll: (params) => api.get('/orders', { params }),
  getById: (id) => api.get(`/orders/${id}`),
  getByInventoryId: (inventoryId) => api.get(`/orders/inventory/${inventoryId}`),
  create: (data) => api.post('/orders', data),
  update: (id, data) => api.patch(`/orders/${id}`, data),
  updateStatus: (id, status) => api.patch(`/orders/${id}/status`, { status }),
  addItem: (id, data) => api.post(`/orders/${id}/items`, data),
};

// ─── TAILORS ─────────────────────────────────────────────────
export const tailorsApi = {
  getAll: () => api.get('/tailors'),
  getById: (id) => api.get(`/tailors/${id}`),
  getWorkload: () => api.get('/tailors/workload'),
  getAssignments: (params) => api.get('/tailors/assignments', { params }),
  getAssignmentById: (id) => api.get(`/tailors/assignments/${id}`),
  assign: (data) => api.post('/tailors/assign', data),
  complete: (id) => api.patch(`/tailors/assignments/${id}/complete`),
  update: (id, data) => api.patch(`/tailors/${id}`, data),
};

// ─── REPORTS ─────────────────────────────────────────────────
export const reportsApi = {
  getDashboard: () => api.get('/reports/dashboard'),
  getProfitLoss: (params) => api.get('/reports/profit-loss', { params }),
  getTailorPerformance: (params) => api.get('/reports/tailor-performance', { params }),
  getInventoryReport: (params) => api.get('/reports/inventory', { params }),
  getFilterOptions: () => api.get('/reports/filter-options'),
  getOrdersByLot: (params) => api.get('/reports/orders-by-lot', { params }),
  getMonthlyProfit: (params) => api.get('/reports/monthly-profit', { params }),
};

// ─── SUPPLIERS ─────────────────────────────────────────────────
export const suppliersApi = {
  getAll: (params) => api.get('/suppliers', { params }),
  getById: (id) => api.get(`/suppliers/${id}`),
  create: (data) => api.post('/suppliers', data),
  update: (id, data) => api.put(`/suppliers/${id}`, data),
  delete: (id) => api.delete(`/suppliers/${id}`),
};

// ─── SETTINGS ─────────────────────────────────────────────────
export const settingsApi = {
  get: () => api.get('/settings'),
  getPublic: () => api.get('/settings/public'),
  update: (data) => api.put('/settings', data),
};

// ─── TAILOR HISTORY ───────────────────────────────────────────
export const tailorHistoryApi = {
  getAll: () => api.get('/tailor-history'),
  getByTailor: (tailorId) => api.get(`/tailor-history/${tailorId}`),
  giveAdvance: (data) => api.post('/tailor-history/advance', data),
  getAdvanceHistory: (tailorId) => api.get(`/tailor-history/advance/${tailorId}`),
  recordPayment: (data) => api.post('/tailor-history/payment', data),
  getWeeklySettlement: (tailorId, weeks) => api.get(`/tailor-history/weekly/${tailorId}`, { params: { weeks } }),
  settleWeekly: (data) => api.post('/tailor-history/settle', data),
  deductFromAdvance: (data) => api.post('/tailor-history/deduct-advance', data),
};  
